import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TeamCard from "./TeamCards";
import Particle from "../Particle";
import useInViewOnce from "../../hooks/useInViewOnce";
import gloria from "../../Assets/Projects/gloria.jpg";
import galindo from "../../Assets/Projects/galindo.jpg";
import golriz from "../../Assets/Projects/golriz.jpg";
import aaron from "../../Assets/Projects/aaron.jpg";
import trinity from "../../Assets/Projects/trinity.jpg";
import andy from "../../Assets/Projects/andy.jpg";

function Team() {
  const teamMembers = [
    {
      name: "Golriz Sedaghat",
      role: "Co-Founder",
      description:
        "Golriz is an Electrical Engineer with over 10 years of wide-ranging experience from the field of biomedical to semiconductor industry. She is dedicated to finding solutions for complex problems through a collaborative and interdisciplinary approach.",
      email: "golriz@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/golriz-sedaghat-25a635105/",
      image: golriz,
    },
    {
      name: "Aaron Enyetu",
      role: "Co-Founder",
      description:
        "Aaron Enyetu is a software engineer specializing in scalable web and mobile applications with a focus on ethical, community-centered design. He leverages full-stack development and tech education to drive innovation and meaningful social impact.",
      email: "aaron@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/aaron-enyetu/",
      image: aaron,
    },
    {
      name: "Triniti Bunton",
      role: "Community Engagement Advisor",
      description:
        "Triniti Bunton is a community leader and workforce development professional with experience advancing equity, access, and economic opportunity through program leadership and cross-sector partnerships.",
      linkedin: "https://www.linkedin.com/in/triniti-bunton-8983a799/",
      image: trinity,
    },
    {
      name: "Andy Hernandez",
      role: "Community Engagement Advisor",
      description:
        "Andy Hernandez is a community relations and engagement professional with over a decade of experience in senior living and people-centered services. He specializes in building trust, coordinating supportive programs, and fostering inclusive environments that help individuals and communities feel connected, supported, and empowered.",
      linkedin: "https://www.linkedin.com/in/andyhdz/",
      image: andy,
    },
    {
      name: "Galindo R Aliyo",
      role: "Administrative Director",
      description:
        "Galindo’s background is in legal practice and research. She has led teams and has driven initiatives focused on justice and innovation. She has also served as the head of research & strategy, overseeing research efforts and strategic direction for management consulting firms.",
      email: "galindo@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/galindo-aliyo-b716a594/",
      image: galindo,
    },
    {
      name: "Gloria Ludigo",
      role: "Operations Manager",
      description:
        "Gloria Ludigo is an Advocate with extensive experience in law, regulatory compliance, legal advisory, project management, and technology. She believes that successful projects begin with a well-prepared team and has contributed to workspaces that deliver quality, timely results, leading to the successful achievement of project goals.",
      email: "gloria@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/gloria-ludigo-b2ab41140/",
      image: gloria,
    },
  ];

  const { ref: topRef, hasEntered: topSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: gridRef, hasEntered: gridSeen } = useInViewOnce({ threshold: 0.18, once: true });

  return (
    <Container fluid className="about-section team-page">
      <Particle />
      <Container className="team-container">
        <header ref={topRef} className={`team-hero team-reveal${topSeen ? " is-seen" : ""}`}>
          <h1 className="team-hero-title">
            Our <strong className="purple">Team</strong>
          </h1>
          <p className="team-hero-lead">
            We empower communities by fostering positive relationships through appropriate technology development.
          </p>
        </header>

        <section
          ref={gridRef}
          className={`team-section team-reveal${gridSeen ? " is-seen" : ""}`}
          aria-label="Team members"
        >
          <Row className="team-grid" style={{ justifyContent: "center" }}>
            {teamMembers.map((member) => (
              <Col key={member.name} md={4} className="team-col">
                <TeamCard
                  imgPath={member.image}
                  title={member.name}
                  role={member.role}
                  description={member.description}
                  email={member.email}
                  linkedin={member.linkedin}
                />
              </Col>
            ))}
          </Row>
        </section>
      </Container>
    </Container>
  );
}

export default Team;
